/**
 * Created by Languagenut on 26/11/2019.
 */


import React  from 'react';

export default class NewZeland extends React.Component {


    constructor(props) {
        super();
        this.props = props;
        this.state = {
            tab:this.props.match.params.tab,
        };
    }

    componentDidMount() {

    }

    componentWillReceiveProps(props){

    }

    render(){
        return <tr/>
    }



}